import React from 'react';
import AQUGpdf from '../../../docs/AQcast_SCICHEM_User_Guide.pdf'
import EPRIUGpdf from '../../../docs/USER_GUIDE_SCICHEMv3.3.pdf'

export default class About extends React.Component {
    render() {
        return (
            <div>
                <h2>SCICHEM 3.3</h2>

                <p>SCICHEM 3.3is a reactive puff model that can be used to calculate
                single or multi-source impacts of emissions at downwind locations. The
                model can be used for both short-range calculations (for example,
                1-hour SO2, 1-hour NO2, 24-hour secondary PM2.5, or 8-hour ozone
                concentrations at fenceline receptors, or long-range calculations for
                primary and secondary pollutant impacts. For 1-hour NO2 applications,
                the model uses an optimized near-source NO-NO2-O3 chemistry scheme.
                For long-range applications or near-field PM2.5/ozone, the full
                chemistry option can be used to calculate downwind ozone and PM2.5
                concentrations.</p>

                <h3>Helpful User Guides</h3>
                <li>
                    <a href={AQUGpdf} target = "_blank">AQcast:SCICHEM User Guide</a>
                </li>

                <li>
                    <a href={EPRIUGpdf} target = "_blank">SCICHEMv3.3 User Guide</a>
                </li>
                <br></br>
                <h4>Major Updates</h4>
                2022-02-09 : Updated SCICHEM to version 3.3
                <br></br>2020-06-20 : Add the option to load a previous project, buildings, fencelines, sources. Add to a previous or uploaded building/fenceline files
                <br></br>2020-06-03 : Updated SCICHEM to version 3.2.2, add area source option and more run options
            </div>

        );
    }
};
